import {observer} from 'mobx-react-lite'
import React from 'react'
import {logger} from 'yougile-util'
import {StatisticsTiles} from './item/tiles'
import {useStatsTimelineStore} from './stats-timeline-store'

export const StatsTimelineTiles = observer(() => {
  const [state, store] = useStatsTimelineStore()

  logger.log(
    `[Events] Rendering ${Object.keys(store.eventsByDay).length} tiles`
  )
  logger.log(`[Events] Events total count: ${Object.keys(store.events).length}`)
  for (const date of Object.keys(store.eventsByDay)) {
    logger.log(
      `[Events] Date: ${date}, Events: ${
        Object.keys(store.eventsByDay[date]).length
      }`
    )
  }

  return (
    <>
      {store.events &&
        state.view === 'card' &&
        Object.keys(store.eventsByDay).map(date => (
          <StatisticsTiles
            key={date}
            date={date}
            restore={store.restore}
            errors={state.errors}
            reportError={store.reportError}
            eventsByDay={store.eventsByDay}
          />
        ))}
    </>
  )
})
